import { render, staticRenderFns } from "./select-multiple.vue?vue&type=template&id=5dbb2b04&scoped=true&"
import script from "./select-multiple.vue?vue&type=script&lang=js&"
export * from "./select-multiple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dbb2b04",
  null
  
)

export default component.exports